/**
 * Read album saved in localstorage and add the album in first position,
 * if album already present remove it and add it in first position
 */
export const addAlbumVisited = (album) => {
    let albums = JSON.parse(localStorage.getItem('albumsVisited')) || [];
    // Remove if already present (by id)
    albums = albums.filter(a => a.id !== album.id);
    // Add to first position
    albums.unshift(album);
    // Optionally limit the list length (e.g., 20)
    if (albums.length > 20) albums = albums.slice(0, 20);
    localStorage.setItem('albumsVisited', JSON.stringify(albums));
}

/**
 * Return the list of albums visited in the past
 */
export const getAlbumVisited = () => {
    return JSON.parse(localStorage.getItem('albumsVisited')) || null;
}